var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBbotBlushing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 163.234,
    height: 190.344,
    viewBox: "0 0 163.234 190.344",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#abc1de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a8c5e7"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_380"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.631,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.746,
    cy: 0.366,
    r: 1.001,
    gradientTransform: "matrix(-0.664, 0.748, -0.847, -0.752, 1.551, 0.083)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#c4d9f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7cade5"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_371",
    x: 51.695,
    y: 77.788,
    width: 42.58,
    height: 33.058,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#3daaf1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_372",
    x: 94.932,
    y: 75.228,
    width: 42.58,
    height: 33.058,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#3daaf1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.921,
    y1: 0.127,
    x2: 0.137,
    y2: 0.816,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#072046"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08142f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#739bd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88a8d1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.674,
    cy: 0.537,
    r: 0.634,
    gradientTransform: "matrix(0.657, -0.754, 0.413, 0.36, -0.035, 0.697)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4f9fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#eaf3fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    stopColor: "#d6e6f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a4c7f0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_379"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.631,
    result: "color-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.919,
    y1: 0.392,
    x2: 0.353,
    y2: 0.885,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4b4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613,
    stopColor: "#de3637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d23633"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_427",
    x: 76.216,
    y: 154.318,
    width: 23.4,
    height: 33.587,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#462626",
    floodOpacity: 0.439
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_427-2",
    x: 76.216,
    y: 154.318,
    width: 23.4,
    height: 33.587,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#af0d1e",
    result: "color-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.905,
    y1: 0.657,
    x2: 0.13,
    y2: 0.602,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fa343f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c40c1b"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_426",
    x: 78.774,
    y: 143.473,
    width: 19.309,
    height: 13.491,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.549
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_426-2",
    x: 78.774,
    y: 143.473,
    width: 19.309,
    height: 13.491,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4f0a0a",
    floodOpacity: 0.62,
    result: "color-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.475,
    y1: -0.025,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a8bcd3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 0.768,
    cy: 0.311,
    r: 0.951,
    gradientTransform: "matrix(-0.907, 0.42, -0.531, -1.147, 1.585, 0.217)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbfcfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#e4edf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#c4d7ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746,
    stopColor: "#7aa5d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ba6db"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_374"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: -4,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.561,
    result: "color-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 0.21,
    cy: 0.622,
    r: 0.587,
    gradientTransform: "matrix(0.583, 0.812, -1.056, 0.758, 0.745, -0.02)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ba6d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b4f68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242c3e"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_21"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.451,
    result: "color-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_26"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur-11"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.451,
    result: "color-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-11"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.67,
    y1: 0.97,
    x2: 0.284,
    y2: 0.039,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9cb66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#fab22b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f88604"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_289",
    x: 4.306,
    y: 83.284,
    width: 16.767,
    height: 25.326,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-12"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffb109",
    floodOpacity: 0.51
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-12"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.67,
    y1: 0.97,
    x2: 0.284,
    y2: 0.039,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fabb33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f88604"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_290",
    x: 5.127,
    y: 83.011,
    width: 19.498,
    height: 25.921,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-13"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffb109",
    floodOpacity: 0.51
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-13"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.921,
    y1: 0.127,
    x2: 0.137,
    y2: 0.816,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#49192e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f0826"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_369",
    x: 32.497,
    y: 33.658,
    width: 119.805,
    height: 98.706,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: -5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-14"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.651
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-14"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_369-2",
    x: 32.497,
    y: 33.658,
    width: 119.805,
    height: 98.706,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-15"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#123c67",
    result: "color-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-15"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.86,
    y1: 0.329,
    x2: 0.744,
    y2: 0.916,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9d63a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b101c"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_373",
    x: 78.035,
    y: 92.693,
    width: 37.184,
    height: 27.244,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-16"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#7fc1fa"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-16"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_433",
    x: 53.179,
    y: 77.907,
    width: 42.58,
    height: 33.058,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-17"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#3daaf1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-17"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_434",
    x: 96.416,
    y: 75.348,
    width: 42.58,
    height: 33.058,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-18"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#3daaf1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-18"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 0.722,
    cy: 0.228,
    r: 0.788,
    gradientTransform: "matrix(0.718, 0.696, -0.489, 0.504, 0.253, -0.42)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcd271"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f99d18"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Line_214",
    x: 63.179,
    y: 97.544,
    width: 17.6,
    height: 18.6,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-19"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff8fe5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-19"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Line_217",
    x: 107.179,
    y: 95.544,
    width: 17.6,
    height: 18.6,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-20"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff8fe5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-20"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Line_215",
    x: 71.179,
    y: 97.544,
    width: 17.6,
    height: 18.6,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-21"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff8fe5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-21"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Line_216",
    x: 115.179,
    y: 95.544,
    width: 17.6,
    height: 18.6,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-22"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff8fe5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-22"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1007",
    "data-name": "Group 1007",
    transform: "translate(9582.57 -2591.978)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_908",
    "data-name": "Group 908",
    transform: "translate(-9584.054 2618.269)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_380-2",
    "data-name": "Path 380",
    d: "M.634,3.38C2.321-.1,9.426-1.4,15.01,1.942S25.517,13.112,21.756,16.1s-10.7-.165-15.925-3.207S-1.053,6.864.634,3.38Z",
    transform: "translate(96.251 129.262) rotate(-43)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1.48, -26.29)",
    filter: "url(#Path_380)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_380-3",
    "data-name": "Path 380",
    d: "M.634,3.38C2.321-.1,9.426-1.4,15.01,1.942S25.517,13.112,21.756,16.1s-10.7-.165-15.925-3.207S-1.053,6.864.634,3.38Z",
    transform: "translate(94.77 155.55) rotate(-43)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M6.831,2.236c1.592-2.1,5.573-8.85,19.831-8.85S50.233-4.506,53.925.411s.542,22.263,0,25.569-4.953,8.289-10.49,9.725c-5,1.3-11.218,3.072-20.024,1.018s-12.359-5.257-15.2-9.235S5.239,4.337,6.831,2.236Z",
    transform: "translate(54.895 126.393)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 17.027,
    cy: 3.24,
    rx: 17.027,
    ry: 3.24,
    transform: "translate(68.092 120.3) rotate(1)",
    fill: "#466ea4",
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1.48, -26.29)",
    filter: "url(#Path_371)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_371-2",
    "data-name": "Path 371",
    d: "M-9203.836,2746.728s-.5-10.068,9.733-10.907,10.738,9.229,10.738,9.229",
    transform: "translate(9266.54 -2646.98)",
    fill: "none",
    stroke: "#f0f3f7",
    strokeLinecap: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1.48, -26.29)",
    filter: "url(#Path_372)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_372-2",
    "data-name": "Path 372",
    d: "M-9203.836,2746.728s-.5-10.068,9.733-10.907,10.738,9.229,10.738,9.229",
    transform: "translate(9309.78 -2649.54)",
    fill: "none",
    stroke: "#f0f3f7",
    strokeLinecap: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_7",
    "data-name": "Subtraction 7",
    d: "M.736,89.206,0,89.2c8.178-.033,19.916-.658,29.4-3.458,8.473-2.5,12.467-4.127,15.83-6.439l.043-.029a28.633,28.633,0,0,0,8.481-8.144c4.781-6.695,7.308-15.283,7.308-24.837V40.6c0-11.331-6.808-20.827-10.866-25.478A30.493,30.493,0,0,0,41.281,8.1L40.9,7.879A60.927,60.927,0,0,0,29.4,2.755C24.591,1.114,16.571.06,8.466,0l.169,0h.534C17.535,0,25.824,1.056,30.8,2.755A60.98,60.98,0,0,1,42.3,7.879l.382.217A30.5,30.5,0,0,1,51.6,15.119a48.88,48.88,0,0,1,7.563,11.459,33.218,33.218,0,0,1,3.3,14.019v5.7c0,9.554-2.527,18.143-7.307,24.837a28.633,28.633,0,0,1-8.476,8.141l-.047.032c-3.362,2.311-7.357,3.936-15.83,6.439a85.188,85.188,0,0,1-16,2.839C9.275,89.1,4.1,89.206.736,89.206Z",
    transform: "translate(83.34 16.748)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_43",
    "data-name": "Ellipse 43",
    cx: 4.936,
    cy: 8.774,
    rx: 4.936,
    ry: 8.774,
    transform: "translate(62.723 126.812) rotate(21)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379-2",
    "data-name": "Path 379",
    d: "M22.44,3.38C20.753-.1,13.648-1.4,8.064,1.942S-2.442,13.112,1.318,16.1s10.7-.165,15.925-3.207S24.127,6.864,22.44,3.38Z",
    transform: "translate(46.002 130.582) rotate(-17)",
    fill: "url(#radial-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1.48, -26.29)",
    filter: "url(#Path_379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379-3",
    "data-name": "Path 379",
    d: "M22.44,3.38C20.753-.1,13.648-1.4,8.064,1.942S-2.442,13.112,1.318,16.1s10.7-.165,15.925-3.207S24.127,6.864,22.44,3.38Z",
    transform: "translate(44.52 156.87) rotate(-17)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1004",
    "data-name": "Group 1004",
    transform: "translate(80.2 118.682)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1004-2",
    "data-name": "Group 1004",
    transform: "translate(0 9.846)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -78.72, -154.82)",
    filter: "url(#Path_427)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_427-3",
    "data-name": "Path 427",
    d: "M-10828.353,1798.944s-.984,4.515-2.386,9.5-3.221,10.431-3.221,10.431,2.433,3.175,4.982,5.84a63.022,63.022,0,0,0,5.218,4.82s3.065-2.573,5.615-5.238a62.962,62.962,0,0,0,4.585-5.422,55.018,55.018,0,0,0-1.96-10.431,51.2,51.2,0,0,0-4.2-9.5h-8.637Z",
    transform: "translate(10912.68 -1644.13)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -78.72, -154.82)",
    filter: "url(#Path_427-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_427-4",
    "data-name": "Path 427",
    d: "M-10828.353,1798.944s-.984,4.515-2.386,9.5-3.221,10.431-3.221,10.431,2.433,3.175,4.982,5.84a63.022,63.022,0,0,0,5.218,4.82s3.065-2.573,5.615-5.238a62.962,62.962,0,0,0,4.585-5.422,55.018,55.018,0,0,0-1.96-10.431,51.2,51.2,0,0,0-4.2-9.5h-8.637Z",
    transform: "translate(10912.68 -1644.13)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1005",
    "data-name": "Group 1005",
    transform: "translate(1.557)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -80.27, -144.97)",
    filter: "url(#Path_426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_426-3",
    "data-name": "Path 426",
    d: "M-10826.972,1767.478l13.407-.337a1.3,1.3,0,0,1,.7.583,1.9,1.9,0,0,1,0,1.03,33.849,33.849,0,0,1-1.045,4.128,32.949,32.949,0,0,1-1.621,3.9,1.3,1.3,0,0,1-.414.545,2.291,2.291,0,0,1-.759.305h-7.1a2.813,2.813,0,0,1-1.276-.305,2.351,2.351,0,0,1-.8-.95l-3-6.51s-.478-1.37,0-1.967S-10826.972,1767.478-10826.972,1767.478Z",
    transform: "translate(10909.37 -1622.17)",
    fill: "url(#linear-gradient-5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -80.27, -144.97)",
    filter: "url(#Path_426-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_426-4",
    "data-name": "Path 426",
    d: "M-10826.972,1767.478l13.407-.337a1.3,1.3,0,0,1,.7.583,1.9,1.9,0,0,1,0,1.03,33.849,33.849,0,0,1-1.045,4.128,32.949,32.949,0,0,1-1.621,3.9,1.3,1.3,0,0,1-.414.545,2.291,2.291,0,0,1-.759.305h-7.1a2.813,2.813,0,0,1-1.276-.305,2.351,2.351,0,0,1-.8-.95l-3-6.51s-.478-1.37,0-1.967S-10826.972,1767.478-10826.972,1767.478Z",
    transform: "translate(10909.37 -1622.17)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1012",
    "data-name": "Group 1012",
    transform: "translate(1.485 0.119)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 8.774,
    cy: 19.742,
    rx: 8.774,
    ry: 19.742,
    transform: "matrix(0.995, -0.105, 0.105, 0.995, -9442.399, 2654.566)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1011",
    "data-name": "Group 1011"
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_374-2",
    "data-name": "Path 374",
    d: "M-9417.786,2796.563s40.089,7.046,63.169,0,45.191-18.89,44.705-43.489-.183-50.475-24.054-64.87-44.036-13.424-71.915-7.532-42.031,29.641-42.031,29.641-13.119,20.894-4.859,51.993,24.052,30.37,34.985,34.257",
    transform: "translate(-118.629 -58.355)",
    fill: "url(#radial-gradient-3)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9584.05, 2591.86)",
    filter: "url(#Path_374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_374-3",
    "data-name": "Path 374",
    d: "M-9417.786,2796.563s40.089,7.046,63.169,0,45.191-18.89,44.705-43.489-.183-50.475-24.054-64.87-44.036-13.424-71.915-7.532-42.031,29.641-42.031,29.641-13.119,20.894-4.859,51.993,24.052,30.37,34.985,34.257",
    transform: "translate(9465.43 -2650.21)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_905",
    "data-name": "Group 905",
    transform: "translate(-9549.057 2710.217) rotate(175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_765",
    "data-name": "Group 765",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 15.472,
    cy: 23.928,
    rx: 15.472,
    ry: 23.928,
    transform: "translate(0 0)",
    fill: "#6493bb"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 15.292,
    cy: 23.568,
    rx: 15.292,
    ry: 23.568,
    transform: "translate(0.36 0.36)",
    fill: "url(#radial-gradient-4)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_21-2",
    "data-name": "Ellipse 21",
    cx: 11.903,
    cy: 20.33,
    rx: 11.903,
    ry: 20.33,
    transform: "translate(6.059 3.238)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1, -0.09, 0.09, -1, 24.55, 120.96)",
    filter: "url(#Ellipse_21)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_21-3",
    "data-name": "Ellipse 21",
    cx: 11.903,
    cy: 20.33,
    rx: 11.903,
    ry: 20.33,
    transform: "matrix(-1, 0.09, -0.09, -1, 28.68, 115.66)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_7-2",
    "data-name": "Subtraction 7",
    d: "M.9,0A8.211,8.211,0,0,0,0,.05C3.219.406,6.212,2.673,8.425,6.435A27.788,27.788,0,0,1,11.874,20.33,27.788,27.788,0,0,1,8.425,34.224C6.212,37.986,3.22,40.254,0,40.61a8.21,8.21,0,0,0,.9.05,8.809,8.809,0,0,0,4.972-1.6,14.378,14.378,0,0,0,4.06-4.357,23.435,23.435,0,0,0,2.737-6.462,30.829,30.829,0,0,0,1-7.913,30.829,30.829,0,0,0-1-7.913A23.434,23.434,0,0,0,9.932,5.954,14.378,14.378,0,0,0,5.872,1.6,8.809,8.809,0,0,0,.9,0Z",
    transform: "translate(16.192 3.238)",
    fill: "#5e6b84",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_26-2",
    "data-name": "Ellipse 26",
    cx: 11.903,
    cy: 20.33,
    rx: 11.903,
    ry: 20.33,
    transform: "translate(6.059 3.238)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1, -0.09, 0.09, -1, 24.55, 120.96)",
    filter: "url(#Ellipse_26)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_26-3",
    "data-name": "Ellipse 26",
    cx: 11.903,
    cy: 20.33,
    rx: 11.903,
    ry: 20.33,
    transform: "matrix(-1, 0.09, -0.09, -1, 28.68, 115.66)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_771",
    "data-name": "Group 771",
    transform: "matrix(0.996, -0.087, 0.087, 0.996, 12.081, 15.354)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.98, -0.17, 0.17, -0.98, 3.22, 106.29)",
    filter: "url(#Path_289)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_289-2",
    "data-name": "Path 289",
    d: "M7.553,0A4.676,4.676,0,0,0,6.362.976,9.559,9.559,0,0,0,5.042,3,33.042,33.042,0,0,1,5.31,8.954a31.736,31.736,0,0,1-.983,5.809s-1.591-.008-2.9-.064A1.888,1.888,0,0,1,.426,13.079,6.042,6.042,0,0,0,.032,14.7a5.367,5.367,0,0,0,.109,1.845A2.033,2.033,0,0,0,1.431,18.1l4.834.169A64.17,64.17,0,0,0,7.576,9.442,77.524,77.524,0,0,0,7.553,0Z",
    transform: "translate(18.07 104.27) rotate(170)",
    fill: "url(#linear-gradient-9)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.98, -0.17, 0.17, -0.98, 3.22, 106.29)",
    filter: "url(#Path_290)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_290-2",
    "data-name": "Path 290",
    d: "M10.464,0A4.909,4.909,0,0,0,8.785,1.327a9.857,9.857,0,0,0-1.252,2.34H4.064A3.25,3.25,0,0,0,2.788,5.93a2.8,2.8,0,0,0,.9,2.191l3.018.022a5.628,5.628,0,0,1,.135,1.692,4.328,4.328,0,0,1-.487,1.487L4.229,11.3a7.314,7.314,0,0,0-1.441,3.373,4.669,4.669,0,0,0,.762,3.71,4.293,4.293,0,0,1-2.461-1.377,4.948,4.948,0,0,1-.681-2.784,7.41,7.41,0,0,1,.483-2.466A5.105,5.105,0,0,1,2.046,9.974,4.81,4.81,0,0,1,.488,8.337,4.356,4.356,0,0,1,.006,6.006,8.176,8.176,0,0,1,1.337,2.141,5.233,5.233,0,0,1,4.064.291Z",
    transform: "translate(21.62 104.12) rotate(170)",
    fill: "url(#linear-gradient-10)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1010",
    "data-name": "Group 1010",
    transform: "translate(-9584.054 2618.27)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, -26.41)",
    filter: "url(#Path_369)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_369-3",
    "data-name": "Path 369",
    d: "M42.774,1.045c12.4-2.364,28.688-1.124,36.369,1.5a60.786,60.786,0,0,1,11.5,5.124,31.3,31.3,0,0,1,9.295,7.24c5.678,6.508,10.866,15.556,10.866,25.478v5.7c0,8.953-2.221,17.714-7.307,24.837A28.85,28.85,0,0,1,94.974,79.1c-3.189,2.192-7,3.829-15.83,6.439C63.963,90.019,42.774,88.86,42.774,88.86c-10.205,0-20.661-2.4-28.262-8.571C5.093,72.65,0,59.5,0,46.085v-3.29C0,27.51,4.995,17.207,17.323,9.475,23.631,5.516,30.379,3.408,42.774,1.045Z",
    transform: "translate(35 43.37)",
    fill: "url(#linear-gradient-11)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, -26.41)",
    filter: "url(#Path_369-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_369-4",
    "data-name": "Path 369",
    d: "M42.774,1.045c12.4-2.364,28.688-1.124,36.369,1.5a60.786,60.786,0,0,1,11.5,5.124,31.3,31.3,0,0,1,9.295,7.24c5.678,6.508,10.866,15.556,10.866,25.478v5.7c0,8.953-2.221,17.714-7.307,24.837A28.85,28.85,0,0,1,94.974,79.1c-3.189,2.192-7,3.829-15.83,6.439C63.963,90.019,42.774,88.86,42.774,88.86c-10.205,0-20.661-2.4-28.262-8.571C5.093,72.65,0,59.5,0,46.085v-3.29C0,27.51,4.995,17.207,17.323,9.475,23.631,5.516,30.379,3.408,42.774,1.045Z",
    transform: "translate(35 43.37)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M-9130.054,1546.837s-1.123-5.618-2.762-10.911-2.389-7.587-8.056-12.177-12.551-7.87-26.04-9.135-27.914,4.077-27.914,4.077l-13.488,6.557,18.172,7.868,23.23-2.016s13.581,2.857,19.436,3.185,5.293-.607,8.29,2.953S-9130.054,1546.837-9130.054,1546.837Z",
    transform: "translate(9269.29 -1493.555)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, -26.41)",
    filter: "url(#Path_373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_373-2",
    "data-name": "Path 373",
    d: "M-9180.768,2745.9a7.978,7.978,0,0,0,8.95,4.933c6.879-1.006,6.823-6.107,6.823-6.107",
    transform: "translate(9269.71 -2641.51)",
    fill: "none",
    stroke: "#f0f3f7",
    strokeLinecap: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, -26.41)",
    filter: "url(#Path_433)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_433-2",
    "data-name": "Path 433",
    d: "M-9203.836,2746.728s-.5-10.068,9.733-10.907,10.738,9.229,10.738,9.229",
    transform: "translate(9268.03 -2646.86)",
    fill: "none",
    stroke: "#f0f3f7",
    strokeLinecap: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, -26.41)",
    filter: "url(#Path_434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_434-2",
    "data-name": "Path 434",
    d: "M-9203.836,2746.728s-.5-10.068,9.733-10.907,10.738,9.229,10.738,9.229",
    transform: "translate(9311.26 -2649.42)",
    fill: "none",
    stroke: "#f0f3f7",
    strokeLinecap: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M-9517.175,1520.918c-4.323,4.61-4.323,11.987,0,15.444s12.217-7.837,17.288,0-4.38,12.909-7.376,16.6c3.227,2.766,24.951-6.281,25.354-16.6s-4.666-16.942-13.367-19.594S-9512.854,1516.307-9517.175,1520.918Z",
    transform: "translate(-6062.936 -6377.507) rotate(-60)",
    fill: "url(#radial-gradient-5)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9584.05, 2591.86)",
    filter: "url(#Line_214)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_214-2",
    "data-name": "Line 214",
    x2: 3,
    y2: 4,
    transform: "translate(70.48 104.84)",
    fill: "none",
    stroke: "#ff8fe5",
    strokeLinecap: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9584.05, 2591.86)",
    filter: "url(#Line_217)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_217-2",
    "data-name": "Line 217",
    x2: 3,
    y2: 4,
    transform: "translate(114.48 102.84)",
    fill: "none",
    stroke: "#ff8fe5",
    strokeLinecap: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9584.05, 2591.86)",
    filter: "url(#Line_215)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_215-2",
    "data-name": "Line 215",
    x2: 3,
    y2: 4,
    transform: "translate(78.48 104.84)",
    fill: "none",
    stroke: "#ff8fe5",
    strokeLinecap: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9584.05, 2591.86)",
    filter: "url(#Line_216)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_216-2",
    "data-name": "Line 216",
    x2: 3,
    y2: 4,
    transform: "translate(122.48 102.84)",
    fill: "none",
    stroke: "#ff8fe5",
    strokeLinecap: "round",
    strokeWidth: 4
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbotBlushing);
export default __webpack_public_path__ + "static/media/BBOT Blushing.dd1b61683bd7a0d07b21936219bd2e8d.svg";
export { ForwardRef as ReactComponent };